import { AuthService } from "@/services";

export default {
  name: "password-recovery-otp",
  components: {},
  props: [],
  data() {
    return {
      otpCode: "",
      loading: false,
      countdownTimer: "00:00",
      remainingMilliseconds: 0,
      clockInterval: null,
      repeatLoading: false,
      rules: {
        required: value =>
          !!value ||
          this.$t("authPage.passwordRecoveryOTPPage.otpCode.validation")
        // min: v => v.length >= 8 || "Min 8 characters",
        // emailMatch: () => `The email and password you entered don't match`
      }
    };
  },
  computed: {
    formattedCountdownTimer() {
      const totalSeconds = Math.floor(this.remainingMilliseconds / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

      return `${formattedMinutes}:${formattedSeconds}`;
    },
    otpToken() {
      return localStorage.getItem("otpToken");
    },
    emailOrMobile() {
      return localStorage.getItem("emailOrMobile");
    },
    ttl() {
      return localStorage.getItem("ttl");
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  methods: {
    init() {
      const storedEndTime = localStorage.getItem("ttl");
      if (storedEndTime) {
        const endTime = parseInt(storedEndTime, 10);
        const now = Date.now();
        const timeLeft = endTime - now;

        if (timeLeft > 0) {
          this.remainingMilliseconds = timeLeft;
          this.startCountdown(endTime);
        } else {
          this.clearCountdown();
          this.remainingMilliseconds = 0;
        }
      } else {
        this.remainingMilliseconds = 0;
      }
    },
    countdown(distance) {
      distance = distance / 1000;
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    },
    verifyPasswordOpt() {
      this.loading = true;
      let otpToken = localStorage.getItem("otpToken");
      AuthService.passwordRecoveryOtp(this.otpCode, otpToken)
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          localStorage.removeItem("emailOrMobile");
          // this.checkIsAuth();
          this.$router.push("password-reset");
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtpCode() {
      this.repeatLoading = true;
      let otpToken = localStorage.getItem("otpToken");
      AuthService.resendPasswordRecoveryOtp(otpToken)
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          const ttl = response.data.data.ttl;
          const endTime = Date.now() + ttl;

          localStorage.setItem("ttl", endTime);
          this.startCountdown(endTime);

          this.$toast.success(response.data.message);
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
          this.clearCountdown();
          this.remainingMilliseconds = 0;
        })
        .finally(() => {
          this.repeatLoading = false;
        });
    },
    startCountdown(endTime) {
      if (this.clockInterval) {
        clearInterval(this.clockInterval);
      }
      this.clockInterval = setInterval(() => {
        const now = Date.now();
        let timeLeft = endTime - now;

        if (timeLeft <= 0) {
          this.remainingMilliseconds = 0;
          clearInterval(this.clockInterval);
          localStorage.removeItem("ttl");
          this.clockInterval = null;
        } else {
          this.remainingMilliseconds = timeLeft;
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.clockInterval) {
        clearInterval(this.clockInterval);
        this.clockInterval = null;
      }
      localStorage.removeItem("ttl");
    }
  }
};
